import { format, utcToZonedTime } from 'date-fns-tz';

import { JobDetailedData } from '@/models/jobDetailed';
import dp from 'date-fns/parse';

export const clearPhoneNumber = (phone: string): string => {
  return phone.replace(/[^0-9 ()]/g, '');
};

/* eslint-disable no-prototype-builtins */
export const flattenObject = (obj: JobDetailedData): Record<string, unknown> => {
  const flattenKeys = {};
  for (const i in obj) {
    if (!obj.hasOwnProperty(i)) {
      continue;
    }
    if (typeof obj[i] == 'object') {
      const flatObject = flattenObject(obj[i]);
      for (const j in flatObject) {
        if (!flatObject.hasOwnProperty(j)) {
          continue;
        }
        flattenKeys[i + '.' + j] = flatObject[j];
      }
    } else {
      flattenKeys[i] = obj[i];
    }
  }
  return flattenKeys;
};

export const compareVersions = (a: string, b: string): number => {
  let i, diff;
  const regExStrip0 = /(\.0+)+$/;
  const segmentsA = a.replace(regExStrip0, '').split('.');
  const segmentsB = b.replace(regExStrip0, '').split('.');
  const l = Math.min(segmentsA.length, segmentsB.length);

  for (i = 0; i < l; i++) {
    diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);
    if (diff) {
      return diff;
    }
  }
  return segmentsA.length - segmentsB.length;
};

export const generateDayTimesAmPm = (step: number): string[] => {
  const date = new Date(1970, 0, 1);
  const times: string[] = [];
  while (date.getDate() === 1) {
    times.push(format(date, 'hh:mm aa'));
    date.setMinutes(date.getMinutes() + step);
  }
  return times;
};

export const convertTimeStringTo24Hours = (timeString: string): string => {
  const dateFromTime = dp(timeString, 'hh:mm aa', new Date());
  return format(dateFromTime, 'HH:mm:ss');
};

export const convertTimeString12to24 = (value: string): string => {
  const [time, modifier] = value.split(' ');
  let hours = time.split(':')[0];
  const minutes = time.split(':')[1];
  if (hours === '12') {
    hours = '00';
  }
  if (modifier === 'PM') {
    hours = String(parseInt(hours, 10) + 12);
  }
  return `${hours}:${minutes}`;
};

// format date to timezone format with the pattern
export const formatDateStringWithTZ = (date: string, timezone: string, pattern: string): string => {
  return format(utcToZonedTime(new Date(date), timezone), pattern);
};
